var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('student-form',{attrs:{"type":"create","label":_vm.$t('students.new_student'),"loading":_vm.loading},on:{"on-submit":_vm.onSave}})}
var staticRenderFns = []

export { render, staticRenderFns }